import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppLayout from "@/components/layout/AppLayout";
import Login from "@/pages/Login";
import RakRoti from "@/pages/RakRoti";
import Dapur from "@/pages/Dapur";
import TongSampah from "@/pages/TongSampah";
import Kasir from "@/pages/Kasir";
import ImportMarketplace from "@/pages/ImportMarketplace";
import GudangMasuk from "@/pages/GudangMasuk";
import Penyesuaian from "@/pages/Penyesuaian";
import KartuStok from "@/pages/KartuStok";
import Laporan from "@/pages/Laporan";
import MasterProduk from "@/pages/MasterProduk";
import MasterMapping from "@/pages/MasterMapping";
import MasterUser from "@/pages/MasterUser";
import Pengaturan from "@/pages/Pengaturan";

function Splash() {
  return (
    <div className="grid min-h-screen place-items-center bg-paper" data-testid="auth-loading">
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-ink border-t-brand" />
    </div>
  );
}

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <Splash />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AdminOnly({ children }) {
  const { isAdmin } = useAuth();
  return isAdmin ? children : <Navigate to="/" replace />;
}

function Allowed({ page, children }) {
  const { user } = useAuth();
  if (user === null) return <Splash />;
  const ok = user && (user.role === "admin" || (user.permissions || []).includes(page));
  return ok ? children : <Navigate to="/" replace />;
}

function LoginRoute() {
  const { user } = useAuth();
  if (user === null) return <Splash />;
  return user ? <Navigate to="/" replace /> : <Login />;
}

const admin = (el) => <AdminOnly>{el}</AdminOnly>;
const allow = (page, el) => <Allowed page={page}>{el}</Allowed>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route element={<Protected><AppLayout /></Protected>}>
            <Route index element={<RakRoti />} />
            <Route path="dapur" element={allow("dapur", <Dapur />)} />
            <Route path="waste" element={allow("waste", <TongSampah />)} />
            <Route path="kasir" element={allow("kasir", <Kasir />)} />
            <Route path="kasir/import" element={allow("import", <ImportMarketplace />)} />
            <Route path="gudang" element={allow("gudang", <GudangMasuk />)} />
            <Route path="penyesuaian" element={allow("penyesuaian", <Penyesuaian />)} />
            <Route path="kartu-stok" element={allow("kartu", <KartuStok />)} />
            <Route path="laporan" element={allow("laporan", <Laporan />)} />
            <Route path="master/produk" element={admin(<MasterProduk />)} />
            <Route path="master/mapping" element={admin(<MasterMapping />)} />
            <Route path="master/user" element={admin(<MasterUser />)} />
            <Route path="pengaturan" element={admin(<Pengaturan />)} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </AuthProvider>
  );
}

export default App;
